// extracted by mini-css-extract-plugin
export default {"wrapper":"Admin_wrapper__Rm3Pl","tabs":"Admin_tabs__ItYRV","sidebarWrap":"Admin_sidebarWrap__6JWOu"};